import { Switch } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface PastSchedulesSwitchProps {
  onSwitchChange: (state: boolean) => void;
  includeExpired: boolean;
}

export const PastSchedulesSwitch = ({
  onSwitchChange,
  includeExpired,
}: PastSchedulesSwitchProps) => {
  const { t } = useTranslation();
  const [showPastEvents, setShowPastEvents] = useState(includeExpired);

  const handleSwitchChange = () => {
    setShowPastEvents((prevShowPastEvents) => !prevShowPastEvents);
    onSwitchChange(!showPastEvents);
  };

  return (
    <div>
      <label>{t('components.schedule.past_switch.label')}</label>
      <Switch
        checked={showPastEvents}
        onChange={handleSwitchChange}
        color="primary"
        inputProps={{ 'aria-label': 'show past events' }}
      />
    </div>
  );
};
